/** Level 7 (claude/level-7-source): Lessons 1–21 (19 teaching, 2 cumulative reviews) plus the lettered lessons not in the book yet (extra.ts); Lesson 22 is the End Check-Up. */
import type { Lesson } from "../types";
import * as A from "./lesson01to10";
import * as B from "./lesson11to21";
import * as X from "./extra";

export const LEVEL7: Lesson[] = [
  A.L7_LESSON1, X.L7_LESSON1A, A.L7_LESSON2, A.L7_LESSON3, A.L7_LESSON4, X.L7_LESSON4A, A.L7_LESSON5, A.L7_LESSON6, A.L7_LESSON7, A.L7_LESSON8, A.L7_LESSON9, A.L7_LESSON10,
  B.L7_LESSON11, B.L7_LESSON12, B.L7_LESSON13, B.L7_LESSON14, B.L7_LESSON15, B.L7_LESSON16, X.L7_LESSON16A, B.L7_LESSON17, X.L7_LESSON17A, B.L7_LESSON18, B.L7_LESSON19, X.L7_LESSON19A, B.L7_LESSON20, B.L7_LESSON21,
];
export { L7_PRE, L7_POST } from "./checkups";
